export default __webpack_public_path__ + "static/media/logowhite.4d773d42.png";